export default function getAction(type:string,data?:any){
    return {type:type,payload:data}
}